import { Stack, Text } from '@mantine/core';
import { useNavigate } from 'react-router';
import { AIActionCard } from 'src/UI/app-container/sidebar/AIActionCard';
import { SiestaBarLayout } from 'src/UI/app-container/sidebar/SiestaBarLayout';
import { useSteering } from 'src/UI/app-container/steering/useSteering';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type Props = {
  onAddManually: () => void;
  onDismiss: () => void;
};

export function ClientsEmptyState({ onAddManually, onDismiss }: Props) {
  const navigate = useNavigate();
  const { state, handleSuggestionClick } = useSteering();

  const response = state.response;
  const isCalendarAction = !response || response.action === 'CONNECT_CALENDAR';
  const label = isCalendarAction ? 'Let\u2019s find clients in your calendar' : response.title;
  const description = isCalendarAction ? undefined : response.message;

  function onFirstCardClick() {
    const href = handleSuggestionClick();
    if (response?.action === 'CREATE_CLIENT') {
      onDismiss();
    }
    if (href) navigate(href);
  }

  return (
    <SiestaBarLayout>
      <Stack align="center" justify="center" h="100%" gap="xl">
        <Stack align="center" gap="xs">
          <Text size="textXl" fw={FONT_WEIGHTS.semibold} c="white">
            Hi, I&apos;m Siesta — your AI assistant.
          </Text>
          <Text size="displayLg" fw={FONT_WEIGHTS.semibold} c="white" ta="center" lts={-0.96}>
            Let&apos;s start by adding your clients.
          </Text>
        </Stack>

        <Stack w={440} gap="sm">
          <AIActionCard
            label={label}
            description={description}
            onClick={response ? onFirstCardClick : undefined}
            href={response ? undefined : '/meetings'}
          />
          <AIActionCard label="Or you can add them manually" onClick={onAddManually} />
        </Stack>
      </Stack>
    </SiestaBarLayout>
  );
}
